import React from 'react';
import Post from '../../components/core/post/Post';
import useActivity from '../../hooks/useActivity';
import usePinnedActivity from '../../hooks/usePinnedActivity';
import { Activity } from '../../types/activity';
import InfiniteScroller from 'react-infinite-scroll-component';
import Loader from '../../components/core/Loader';
import { Box, CircularProgress } from '@mui/joy';

type Props = {};

export default function ActivityScroller(_props: Props) {
  const activityQuery = useActivity();
  const pinnedActivity = usePinnedActivity();

  if (!activityQuery.isSuccess) {
    return <CircularProgress />;
  }

  const {
    fetchNextPage,
    hasNextPage,
    data: { pages },
  } = activityQuery;

  const items: Array<Activity> = [];

  (pinnedActivity.data?.items || []).forEach((item) => {
    items.push(item);
  });
  pages.forEach((page) => {
    items.push(...page.items);
  });

  const loadMoreItems = (): void => {
    fetchNextPage();
  };

  return (
    <InfiniteScroller
      dataLength={items.length}
      hasMore={!!hasNextPage}
      loader={
        <div className="my-5">
          <Loader />
        </div>
      }
      next={loadMoreItems}
    >
      {items.map((item: Activity) => {
        const key = `${item._id}-${item.comments.length}`;
        return (
          <div key={key} className="pb-4">
            <Post
              post={item as any}
              hideQuickNavigate={false}
              refetch={activityQuery.refetch}
            />
          </div>
        );
      })}
    </InfiniteScroller>
  );
}
